import styled from 'styled-components';

import sailShipImage from '../../../images/sail-ship.png';
import { translate } from '../helpers/translate.helper';
import { Box } from '../ui/Box';

import { ErrorPageContent } from './ErrorPageContent';
import { errorPageBackgroundStyles } from './errorPageStyles';

const NotFoundBackground = styled(Box)`
    ${errorPageBackgroundStyles};
    background-image: radial-gradient(
            176.41% 74.53% at 25.47% 50%,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.25) 33.33%,
            rgba(0, 0, 0, 0.5) 66.67%,
            rgba(0, 0, 0, 0.5) 100%
        ),
        url(${sailShipImage});
`;

export const NotFoundErrorPage = () => {
    return (
        <NotFoundBackground>
            <ErrorPageContent
                errorCode={translate('notFound.errorCode')}
                title={translate('notFound.title')}
                description={translate('notFound.description')}
            />
        </NotFoundBackground>
    );
};
